import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { ExplanationService } from '../../explanation.service';
import { ExplanationMessage } from '../../explanation-message';
import { AssessmentCriteria } from '../assessment-criteria';
import { AssessmentCriteriaService } from '../assessment-criteria.service';
import { ActivatedRoute } from '@angular/router';
import { SemsoSnackbarService } from '../../../semso-snackbar.service';
import { environment } from 'environments/environment';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-assessment-form',
  templateUrl: './assessment-form.component.html',
  styleUrls: ['./assessment-form.component.scss']
})
export class AssessmentFormComponent implements OnInit {
  private examinationId;
  private workprocessCode;
  public cijferWaardeForm: FormGroup = null;

  @Input('assessmentCriteria') assessmentCriteria: AssessmentCriteria;
  @Input('coreTaskId') coreTaskId: number;
  @Output() updated = new EventEmitter<boolean>();

  constructor(private explanationService: ExplanationService,
    private assessmentCriteriaService: AssessmentCriteriaService, private route: ActivatedRoute,
    private fb: FormBuilder, private snackbar: SemsoSnackbarService) { }

  ngOnInit() {
    this.route.params.subscribe(data => {
      this.examinationId = data.examinationId;
      this.workprocessCode = data.workprocessId;
    });

    this.assessmentCriteriaService.assessmentCriteriaError$.subscribe(data => {
      this.snackbar.error('Fout bij het versturen van het resultaat');
    });

    this.cijferWaardeForm = this.fb.group({
      cijferWaarde: [this.assessmentCriteria.waarde]
    });
  }

  ngOnDestroy() {

  }

  updateAssessmentCriteria(e) {    
    this.assessmentCriteriaService.postAssessmentCriteria(this.examinationId, this.workprocessCode, {
      beoordelingsVormId: this.assessmentCriteria.beoordelingsvormId,
      waarde: e.target.value
    }).subscribe((result: boolean) => {
      this.updated.emit(result);
    });
  }

  openSideNav() {
    this.explanationService.setExplanationSourceUrl(`${environment.api}/kerntaken/${this.coreTaskId}/pdf/gevuld`)
    this.explanationService.openExplanation(this.assessmentCriteria.toelichtingPagina);
  }

  onlyNumericInput(e) {

    var invalidChars = ["-","+","e"];

    if (invalidChars.includes(e.key)) {
      e.preventDefault();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/examination/workprocess/assessment-form/assessment-form.component.ts